<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-non-bodymatter element-container-single element-type-titlepage title-page" id="title-page">
<div class="title-page-title-subtitle-block">
<h1 class="title-page-title case-upper">SEVEN REASONS YOUR CHURCH WILL NEVER HAVE REVIVAL</h1>
<h2 class="title-page-subtitle case-upper">A MESSAGE FOR PASTORS</h2>
</div>
<div class="title-page-contributor-block">
<div class="title-page-contributor-primary-block">
<h2 class="title-page-contributor title-page-contributor-primary title-page-contributor-without-introduction"><span class="title-page-contributor-name case-upper">JONATHAN SHUTTLESWORTH</span></h2>
</div>
</div>
<div class="publisher-block">
<div class="title-page-publisher-logo-block title-page-publisher-logo-aspect-wide">
<div class="title-page-publisher-logo-size-container publisher-logo-width-1000-pad-207-1000">
<a class="link-contains-image" href="http://www.riseuppublications.com" target="_blank"><img alt="Rise UP Publications" class="title-page-publisher-logo-image" src="images/riseup_logo_primary.jpg"/></a>
</div>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title-page.vue?4c9e159d